import React from 'react';

import { Button } from '@eika/button';
import { InfoCard } from '@eika/card';
import { Link } from '@eika/link';
import { Loader } from '@eika/loader';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { ErrorCardWrapper } from '../../components/shared/ErrorCardWrapper';
import { useConfig } from '../../defaultConfig';
import { useKredittbankenTasks } from '../../fetchHooks/useKredittbankenTasks';
import useTranslation from '../../hooks/useTranslation';

import './KredittbankenKyc.scss';

const KredittbankenKyc: React.FC = () => {
    const translated = useTranslation();
    const { featureToggles, kredittbankenKycReturnLink } = useConfig();
    const {
        data: tasks,
        isLoading,
        error,
        refetch,
    } = useKredittbankenTasks({ enabled: featureToggles.enableKredittbankenTasks });

    const kycTask = tasks && tasks.find((task) => task.category === 'ANSWER_KYC');

    if (isLoading) {
        return (
            <div className="sgw-center-loader">
                <Loader />
            </div>
        );
    }

    if (error) {
        return (
            <ErrorCardWrapper
                title={translated.errors.somethingWentWrong}
                iconType={RichIconTypes.NETTVERKSBRUDD_HARE}
                exception={error}
                isModal
            >
                <Button onClick={() => refetch()}>{translated.tryAgain}</Button>
            </ErrorCardWrapper>
        );
    }

    return (
        <InfoCard className="kredittbanken-kyc__info" skipBackground>
            <RichIcon className="kredittbanken-kyc__icon" type={RichIconTypes.KLOKKE} />
            <p>{translated.kredittbanken.kycInfo}</p>
            {kycTask && kredittbankenKycReturnLink && (
                <Link
                    className="kredittbanken-kyc__link"
                    linkType="button-positive"
                    href={`${kycTask.url}${kredittbankenKycReturnLink.url}`}
                >
                    {translated.kredittbanken.category[kycTask.category]}
                </Link>
            )}
        </InfoCard>
    );
};

export default KredittbankenKyc;
